module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "FMH",
    attrs: {
      "id": "cont"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 7. ",
      "epub:type": "pagebreak",
      "id": "pg_7",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Table of Contents")])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('li', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/editors_note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Editor’s Note")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('b', [_c('span', {
    staticClass: "color1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/brief_introduction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brief Introduction on Pie Crusts")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/brief_introduction#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Never-Fail” Pie Crust")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/brief_introduction#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Single (One-Crust) Pie Shell")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/brief_introduction#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standard Pastry for a Two-Crust Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/brief_introduction#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No-Roll “Instant” Pie Crust")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/brief_introduction#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookie Crust")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PIES")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT1"
  }, [_c('b', [_c('span', {
    staticClass: "color1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Classics")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angel Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bob Andy Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterscotch Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Funeral Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Impossible Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Millionaire Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sawdust Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schnitz Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speedy Custard Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 8. ",
      "epub:type": "pagebreak",
      "id": "pg_8",
      "role": "doc-pagebreak"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Regional Favorites")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Door County Belgian Prune Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illinois Pumpkin Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Michigan Cherry Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Navy Bean Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ohio Buckeye Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shaker Lemon Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sour Cream Raisin Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Win Schuler’s Grasshopper Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('b', [_c('span', {
    staticClass: "color1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Desperation” Pies")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttermilk Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chess Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hoosier Pie (Indiana Sugar Cream Pie)")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mock Apple (Ritz Cracker) Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shoofly Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Milk Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vinegar Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('b', [_c('span', {
    staticClass: "color1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Midwestern Ingredients")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-American Apple Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Walnut Chocolate Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bluebarb Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Cream Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chokecherry Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concord Grape Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 9. ",
      "epub:type": "pagebreak",
      "id": "pg_9",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Strawberry Pie")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manoomin (Wild Rice) Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple Syrup Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Polka-Dot Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Oatmeal Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persimmon Chiffon Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhubarb Custard Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('b', [_c('span', {
    staticClass: "color1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retro Favorites")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Cream Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Marshmallow Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Rum Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cottage Cheese Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberry Velvet Pie ")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heavenly Fluff Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple Refrigerator Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Frosting Lemon Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sky-High Strawberry Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Star-Spangled Cherry Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('b', [_c('span', {
    staticClass: "color1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Handheld Pies")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amish Fry Pie")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Runza")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "Cooper_Md_BT_Medium_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UP (Upper Peninsula) Pasty")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0